// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@5.2.7_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-fade-enter-active[data-v-37a6045e],.slide-fade-leave-active[data-v-37a6045e]{transition:all .1s ease}.slide-fade-enter[data-v-37a6045e],.slide-fade-leave-to[data-v-37a6045e]{opacity:0;transform:translateY(-10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
